export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENTS_LOADING = 'SET_EVENTS_LOADING';
export const SET_UNREAD_ALERTS_COUNTER = 'SET_UNREAD_ALERTS_COUNTER';
export const ADD_TOAST_EVENT = 'ADD_TOAST_EVENT';
export const REMOVE_TOAST_EVENT = 'REMOVE_TOAST_EVENT';
export const ADD_EVENTS_TO_EVENTS = 'ADD_EVENTS_TO_EVENTS';
export const UPDATE_EVENTS = 'UPDATE_EVENTS';